import React /* , { useEffect, useState } */ from 'react';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
/* import { Collapse } from 'react-bootstrap'; */
import classNames from 'classnames';

const PayMethod = ({ id, setHover, method, setMethod }) => {
 //const [show, setShow] = useState(false);

 return (
  <div
   className={classNames('px-0', { 'd-none d-sm-block': false })}
   onMouseEnter={() => setHover(method)}
   onMouseLeave={() => setHover(null)}
   onClick={() => setMethod(method)}
  >
   <Flex className="cursor-pointer fs--1">
    <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '50px', height: '50px' }}>
     <FontAwesomeIcon icon="circle" className="fa-stack-2x fs-1 text-300" />
     <Avatar src={method.src} size={'2xl'} className={classNames({ 'status-online': method.id === id })} />
    </span>
   </Flex>
  </div>
 );
};

PayMethod.propTypes = {
 id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
 setHover: PropTypes.func,
 method: PropTypes.object,
 setMethod: PropTypes.func
};

export default PayMethod;
